export const WhatsNewMenuIcon = ({
    width = 16,
    height = 16,
    color = "#1D201E",
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
    >
        <rect width={width} height={height} fill="white" fill-opacity="0.01" />
        <path
            d="M16.2502 3.75V5.10625L3.52517 7.41875C3.23397 7.472 2.97112 7.62686 2.78342 7.85576C2.59571 8.08467 2.49534 8.37276 2.50017 8.66875V11.3812C2.49534 11.6772 2.59571 11.9653 2.78342 12.1942C2.97112 12.4231 3.23397 12.578 3.52517 12.6312L5.00017 12.85V15C5.00017 15.3315 5.13186 15.6495 5.36628 15.8839C5.6007 16.1183 5.91865 16.25 6.25017 16.25H11.2502C11.5817 16.25 11.8996 16.1183 12.134 15.8839C12.3685 15.6495 12.5002 15.3315 12.5002 15V14.2125L16.2502 14.8938V16.25H17.5002V3.75H16.2502ZM11.2502 15H6.25017V13.0813L11.2502 13.9875V15ZM3.75017 11.3562V8.64375L16.2502 6.375V13.625L3.75017 11.3562Z"
            fill={color}
        />
    </svg>
);
